export default "__VITE_ASSET__CVqVLCee__"